import restApi from "../../http.js";
import session from "../session";
import env from "../../env.js";
const url = "https://insights.algolia.io/1/events";
const requestDefaults = {
  method: "POST",
  url: url,
  headers: {
    "x-algolia-api-key": env.algolia().token,
    "x-algolia-application-id": env.algolia().appId,
  },
};

function getUID(){
 return session.getUserInfo() ? session.getUserInfo().id : 'visitor';
}

export default class AlgoliaApi {
    trackClick(name,params) {
    return restApi({
      ...requestDefaults,
      data: {
        events: [
          {
            eventType: "click",
            eventName: name,
            index: params.index,
            userToken: getUID(),
            objectIDs: [params.objectID],
          }
        ]
      }
    });
  }
  trackView(name, params) {
    return restApi({
      ...requestDefaults,
      data: {
        events: [
          {
            eventType: "view",
            eventName: name,
            index: params.index,
            userToken: getUID(),
            objectIDs: [params.objectID],
            queryID: params.queryID
          },
        ],
      },
    });
  }
  trackAddToCart(name, params) {
    return restApi({
      ...requestDefaults,
      data: {
        events: [
          {
            eventType: "conversion",
            eventName: name,
            index: params.index,
            userToken: getUID(),
            objectIDs: [params.objectID],
            queryID: params.queryID
          },
        ],
      },
    });
  }
}
